import { PAY_SECTION, POWER_FEATURES, POWER_SECTION } from '../../../data/site';

const POWER_ICONS = [
  'https://cdn.prod.website-files.com/68f92bd9b64e660d33bc67d7/68fd40190941b30df97671dd_Icon%2001.svg',
  'https://cdn.prod.website-files.com/68f92bd9b64e660d33bc67d7/68fd40194efeaf17e658814b_Icon%2002.svg',
  'https://cdn.prod.website-files.com/68f92bd9b64e660d33bc67d7/68fd40181b83b634dc93eca1_Icon%2003.svg',
  'https://cdn.prod.website-files.com/68f92bd9b64e660d33bc67d7/68fd40195ddb00250d032d2f_Icon%2004.svg',
] as const;

export function StickyPayPowerSection() {
  return (
    <div className="sticky">
      <section className="pay">
        <div data-w-id="533c1156-92ca-e18d-46fc-7b13ab4f7ea4" style={{WebkitTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', MozTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', msTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', transform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', opacity: '0', filter: 'blur(5px)'}} className="pay-wrap">
          <div className="pay-image-wrap image-parallax">
            <img
              src={PAY_SECTION.image}
              loading="lazy"
              alt={PAY_SECTION.alt}
              className="fit-cover scale-image"
              decoding="async"
            />
            <img src={PAY_SECTION.connectImage} loading="lazy" style={{WebkitTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', MozTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', msTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', transform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', opacity: '0', filter: 'blur(5px)'}} data-w-id="2cbcb4f8-9388-5e6f-5331-e8b2807e628a" alt={PAY_SECTION.connectImageAlt} className="connect-image" />
          </div>
        </div>
      </section>
      <section className="power">
        <div className="container-large">
          <div className="power-wrap">
            <div className="section-header-wrap">
              <div className="section-header-left">
                <div className="heading-wrap">
                  <h2 className="text-white">{POWER_SECTION.title}</h2>
                </div>
                <div className="subtitle-wrap left-small">
                  <div className="paragraph-02 text-dark-grey">{POWER_SECTION.subtitle}</div>
                </div>
              </div>
            </div>
            <div className="power-main-wrap">
              <div className="power-left">
                <div className="power-list-wrap">
                  {POWER_FEATURES.map((feature, index) => (
                    <div key={feature.title} className="power-list">
                      <div className="power-icon-wrap">
                        <img src={POWER_ICONS[index]} loading="lazy" alt="" className="power-icon" />
                      </div>
                      <div className="power-text-wrap">
                        <div className="paragraph-01 text-white">{feature.title}</div>
                        <div className="paragraph-02 text-dark-grey">{feature.description}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div data-w-id="486eee5a-d837-1299-71ba-95f1a1cbeb99" style={{WebkitTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', MozTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', msTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', transform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', opacity: '0', filter: 'blur(5px)'}} className="power-right">
                <div className="power-image-wrap">
                  <img src={POWER_SECTION.image} loading="lazy" alt={POWER_SECTION.imageAlt} className="fit-cover" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
